import { Navigate } from 'react-router-dom';
import useLastDynamicTokenIdUtil from '../hooks/useLastDynamicTokenIdUtil';

const DynamicNftRedirect = () => {
  const lastV2 = useLastDynamicTokenIdUtil();
  return lastV2 ? <Navigate to={lastV2.toString()} replace /> : null;
};

export default DynamicNftRedirect;
